<template>
	<div>
		<router-view />
		<floating-chat
			v-if="hasIdCompany && $route.name !== 'timeline'"
			:idPerson="person._id"
			:sender="userProfile.name"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Pusher from 'pusher-js';
export default {
	name: 'Guest',
	props: {
		fromGeo: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		FloatingChat: () => import('@/components/persons/FloatingChat'),
	},
	computed: {
		hasIdCompany() {
			return this.person && this.person.idCompany;
		},
		...mapGetters({
			person: 'Person/person',
		}),
	},
	created() {
		this.pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
			cluster: process.env.VUE_APP_PUSHER_CLUSTER,
		});
		this.pusher.connection.bind('update', function(err) {
			console.error(err);
		});
		this.channel = this.pusher.subscribe('userTypePerson');
		this.channel.bind('updatePersonData', data => this.$emit('updatePersonData', data));
		this.$on('updatePersonData', async data => {
			if (this.userProfile.idPerson === data.personId) {
				await this.getPerson(this.userProfile.idPerson);
				await this.getLodgingsOfPerson(this.userProfile.idPerson);
				this.setDocumentBadge();
			}
		});
	},
	methods: {
		...mapActions({
			getPerson: 'Person/getPerson',
			getLodgingsOfPerson: 'Lodging/getLodgingsOfOnlyPerson',
		}),
		...mapMutations({ setDocumentBadge: 'Person/setDocumentBadge' }),
	},
};
</script>

<style lang="scss" scoped>
.btnMap {
	opacity: 0.8;
	position: fixed;
	bottom: 90px;
	right: 38px;
}
</style>
